import React, { useEffect, useRef, useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import SecurityService from "./components/service/SecurityService";
import { confirmDialog } from "primereact/confirmdialog";
import { useHistory } from "react-router";
import { useToast } from "./components/other/Toast";
import { Toast } from "primereact/toast";

function IdleTimer() {
  const history = useHistory();
  let isTimedOut = false;
  let flag = false;
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);

  const accept = () => {
    setLoading(true);
    SecurityService.getRefreshToken()
      .then((response) => {
        if (response.data.jti) {
          sessionStorage.setItem("token", response.data.jti);
          sessionStorage.setItem("access_token", response.data.jti);
          sessionStorage.setItem("refresh_token", response.data.jti);
          sessionStorage.setItem("expires_in", eval(Date.now()));
        } else {
          toast.current.show({
            severity: "error",
            summary: "Error Message",
            detail: "Error. Please Login!!!",
          });
          window.location.href = "/login";
        }
      })
      .catch((error) => {
        toast.current.show({
          severity: "error",
          summary: "Error Message",
          detail:
            error.response && error.response.data && error.response.data.msg,
        });
        window.location.href = "/login";
      }).finally(() => {
        setLoading(false);
      });

    flag = false;
  };

  const checkSessionExpired = (val) => {
    //console.log(
    // "session storage time ",
    //   sessionStorage.getItem("expires_in"),
    //   " now",
    //   Date.now(),
    //   "diff",
    //   Date.now() - sessionStorage.getItem("expires_in")
    // );
    // if (!val && Date.now() - sessionStorage.getItem("expires_in") > 3500000) {
    //   sessionStorage.clear();
    //   window.location.href = "/login";

    //   flag = true;
    // } else
    if (!loading && (Date.now() - sessionStorage.getItem("expires_in") > 500000)) {
      accept();
    }
  };

  // useEffect(() => {
  //   setInterval(() => checkSessionExpired(flag), 1000);
  //   return () => {
  //     clearInterval();
  //   };
  // }, []);

  const handleOnIdle = (event) => {
    //console.log("last active", getLastActiveTime());
    const accept = () => {
      reset();
    };

    const reject = () => {
      sessionStorage.clear();
      window.location.href = "/login";
    };

    if (isTimedOut) {
      sessionStorage.clear();
      window.location.href = "/login";
    } else {
      confirmDialog({
        message: "You Have Been Idle! Are You want to stay?",
        header: "Confirmation",
        icon: "pi pi-exclamation-triangle",
        accept,
        reject: () => reject(),
      });
    }
  };

  const handleOnActive = (event) => {
    // console.log("user is active", event);
    //console.log("time remaining", getRemainingTime());
    setUserClickTime(new Date());
    isTimedOut = false;
  };

  const [userClickTime, setUserClickTime] = useState(new Date());
  const handleOnAction = (event) => {
    // console.log("user did something", event);
    isTimedOut = false;
    setUserClickTime(new Date());
    checkSessionExpired();
  };

  const { getRemainingTime, getLastActiveTime, reset } = useIdleTimer({
    timeout: 1000 * 60 * 2,
    // onIdle: handleOnIdle,
    onActive: handleOnActive,
    onAction: handleOnAction,
    debounce: 500,
  });

  return (
    <>
      <Toast ref={toast} />
    </>
  );
}
export default IdleTimer;
